import React from 'react'
import ProceedIcon from "../../assets/images/ProceedIcon.svg";
import { gtmPush } from '../../analytics/useGtmPageview.tsx';


const SubmitButton = ({ onClick, text, type = "button", disabled = false, Icon = ProceedIcon, style = {}, className = "get-started", ariaLabel }) => {
  
  const handleClick = (e) => {
            // ✅ Push event to GTM
      gtmPush("button_click", {
        elementId: "submit-button",
        button_text: text,
        page_path: window.location.pathname + window.location.search,
      });
  
      // ✅ Call the parent’s onClick if provided
      if (onClick) {
        onClick(e);
      }
    };
  const buttonClasses = `step-btn ${className}`
  return (
    <button className={buttonClasses} onClick={handleClick} type={type} disabled={disabled} style={{...style}} {...(ariaLabel && { 'aria-label': ariaLabel })}>
      <img src={Icon} alt='' />
      {text}
    </button>
  )
}

export default SubmitButton
